<template>
    <!-- NOTE: Add class 'vld-parent' to parent container when is-full-page is set to false! -->
    <loading-overlay
            :active="active"
            :can-cancel="false"
            :is-full-page="fullPage"
            :color="color"
            :height="height"
            :width="width"
            :loader="loader"
            :z-index="zIndex"
            :opacity="opacity"
    />
</template>
<script>
    import LoadingOverlay from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        components: {
            LoadingOverlay,
        },
        props: {
            loader: {
                type: String,
                required: false,
                default: 'spinner',
            },
            loading: {
                type: Boolean,
                required: true,
                default: false,
            },
            color: {
                type: String,
                required: false,
                default: '#1ACEB3',
            },
            fullPage: {
                type: Boolean,
                required: false,
                default: false,
            },
            height: {
                type: Number,
                required: false,
                default: 70,
            },
            width: {
                type: Number,
                required: false,
                default: 70,
            },
            opacity: {
                type: Number,
                required: false,
                default: 0.5,
            },
            zIndex: {
                type: Number,
                required: false,
                default: 999,
            },
        },
        data() {
            return {
                active: this.loading,
            };
        },
        methods: {
            setActive() {
                this.active = true;
            },
        },
        watch: {
            loading(newValue) {
                this.active = newValue;
            },
        },
    };
</script>
